import { NgModule } from '@angular/core';
import { MapsEditorRoutingModule } from './maps-editor-routing.module';
import { DvmMapEditorModule } from '@3ddv/ngx-dvm-map-editor';

@NgModule({
  declarations: [],
  imports: [
    MapsEditorRoutingModule,
    DvmMapEditorModule
  ],
})
export class MapsEditorModule { }
